import { render, staticRenderFns } from "./datepicker_th.vue?vue&type=template&id=080e8b4e&scoped=true"
import script from "./datepicker_th.vue?vue&type=script&lang=js"
export * from "./datepicker_th.vue?vue&type=script&lang=js"
import style0 from "./datepicker_th.vue?vue&type=style&index=0&id=080e8b4e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080e8b4e",
  null
  
)

export default component.exports